export default "svg {\n  width: 305px;\n  height: 165px;\n}";